(function importImagesProcessDefinition() {
    'use strict';
    angular.module('Entities')
        .service('importImagesProcessService', [
                        'restUrlBuilder', '$injector', '$q', 'config', 'errorsExtend', 'fileDownloader',
            function importImagesProcessService(restUrlBuilder, $injector, $q, config, errorsExtend, fileDownloader) {

                this.get = function get(selectedImportState, docTypeId, dateFrom, dateTo, page, itemsPerPage, order) {
                    var params = {
                        stateId: selectedImportState != null ? selectedImportState.id : null,
                        documentTypeId : docTypeId,
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                        Page: page, 
                        ItemPerPage: itemsPerPage,
                        OrderBy: order
                    };

                    return restUrlBuilder.all('processImages')
                        .get({ params: params });
                };

                this.Purge = function Purge(date, states) {
                    var params = {
                        date: date,
                        StateIds: states
                    };

                    return restUrlBuilder.all('processImages/Purge').post(params);
                }

                this.PurgeById = function Purge(id) {
                    return restUrlBuilder.one('processImages/PurgeById', id).post();                    
                }


                this.getPurgeCount = function getPurgeCount(date, states) {
                    var params = {
                        date: date,
                        StateIds: states
                    };

                    return restUrlBuilder.all('processImages/GetPurgeCount')
                        .get({ params: params });
                }

                this.getById = function getById(id) {
                    return restUrlBuilder.one('processImages', id).get();
                }

                this.downloadFile = function (file) {
                    var defered = $q.defer();
                    var promise = defered.promise;


                    restUrlBuilder.one('processImages/Download', file.reference).get().then(function (result) {
                        var success = fileDownloader.saveAs(result, file.name);
                        if (!success) {
                            defered.reject('Api failed');
                        }

                        defered.resolve(result);

                    }, function (error) {
                        if (error.status === 204) {
                            defered.reject('The process has not files');
                        } else {
                            defered.reject('Api failed');
                        }
                    });
                    
                    return promise;
                }

                this.create = function create(process, files) {
                    if (process == null) {
                        throw "document no puede ser null";
                    }

                    if (files == null || files.size <= 0) {
                        throw "file no puede ser null";
                    }

                    var $upload = $injector.get('Upload');
                    if ($upload == null)
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";

                    return $upload.upload({
                        url: config.apiUrl('/processImages/UploadProcessImage'),
                        method: 'POST',
                        fields: { processImageContainer: JSON.stringify(process) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };
            }
        ]);

})();